import React, { useState, useEffect } from "react";
import { getProspects, updateProspect } from "../../api";
import { Building2, GripVertical } from "lucide-react";

const COLUMNS = [
  { id: "nouveau", label: "Nouveau", color: "border-t-blue-500" },
  { id: "contacte", label: "Contacté", color: "border-t-amber-500" },
  { id: "relance", label: "Relance", color: "border-t-purple-500" },
  { id: "converti", label: "Converti", color: "border-t-emerald-500" },
  { id: "perdu", label: "Perdu", color: "border-t-neutral-400" },
];

const PipelinePanel = () => {
  const [prospects, setProspects] = useState([]);
  const [dragId, setDragId] = useState(null);
  const [overCol, setOverCol] = useState(null);

  const load = async () => {
    const res = await getProspects();
    setProspects(res.data);
  };
   
  useEffect(() => { load(); }, []);

  const onDrop = async (status) => {
    setOverCol(null);
    const id = dragId;
    setDragId(null);
    if (!id) return;
    const p = prospects.find((x) => x.id === id);
    if (!p || p.status === status) return;
    setProspects((list) => list.map((x) => (x.id === id ? { ...x, status } : x)));
    try {
      await updateProspect(id, { status });
    } catch (e) {
      load();
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading font-bold text-xl text-neutral-900">Pipeline commercial</h2>
        <span className="text-sm text-neutral-500">{prospects.length} prospects · glissez-déposez les cartes</span>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {COLUMNS.map((col) => {
          const items = prospects.filter((p) => (p.status || "nouveau") === col.id);
          return (
            <div
              key={col.id}
              onDragOver={(e) => { e.preventDefault(); setOverCol(col.id); }}
              onDragLeave={() => setOverCol((c) => (c === col.id ? null : c))}
              onDrop={() => onDrop(col.id)}
              className={`bg-neutral-100 rounded-xl border-t-4 ${col.color} p-3 min-h-[300px] transition-colors ${
                overCol === col.id ? "bg-brand/5 ring-2 ring-brand/30" : ""
              }`}
            >
              <div className="flex items-center justify-between mb-3 px-1">
                <span className="font-semibold text-sm text-neutral-800">{col.label}</span>
                <span className="text-xs font-bold bg-white text-neutral-600 rounded-full px-2 py-0.5">{items.length}</span>
              </div>
              <div className="space-y-2">
                {items.map((p) => (
                  <div
                    key={p.id}
                    draggable
                    onDragStart={() => setDragId(p.id)}
                    onDragEnd={() => setDragId(null)}
                    className={`bg-white rounded-lg border border-neutral-200 p-3 cursor-grab active:cursor-grabbing shadow-sm hover:shadow-md transition-shadow ${
                      dragId === p.id ? "opacity-50" : ""
                    }`}
                  >
                    <div className="flex items-start gap-2">
                      <GripVertical size={14} className="text-neutral-300 mt-0.5 shrink-0" />
                      <div className="min-w-0">
                        <div className="flex items-center gap-1.5">
                          <Building2 size={13} className="text-brand shrink-0" />
                          <span className="font-semibold text-sm text-neutral-900 truncate">{p.societe}</span>
                        </div>
                        <p className="text-xs text-neutral-500 mt-1 truncate">{p.contact || p.email || "—"}</p>
                        {p.ville && <p className="text-xs text-neutral-400 truncate">{p.ville} · {p.secteur}</p>}
                        {p.dolibarr_socid && <span className="inline-block mt-1 text-[10px] text-emerald-600">✓ Dolibarr</span>}
                      </div>
                    </div>
                  </div>
                ))}
                {items.length === 0 && (
                  <p className="text-xs text-neutral-400 text-center py-6">Déposez ici</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PipelinePanel;
